// extracted by mini-css-extract-plugin
export default {"Logo_isLink":"Logo_Logo_isLink__Wwv93"};